import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import { FiPlus, FiEdit, FiTrash2, FiVideo } from 'react-icons/fi';
import toast from 'react-hot-toast';

const GerenciarGaleriaVideos = () => {
  const [videos, setVideos] = useState([]);
  const [viagens, setViagens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [videoEdit, setVideoEdit] = useState(null);
  const [formData, setFormData] = useState({
    titulo: '',
    url: '',
    descricao: '',
    ordem: 0,
    viagem_id: ''
  });

  useEffect(() => {
    fetchVideos();
    fetchViagens();
  }, []);

  const fetchVideos = async () => {
    try {
      const response = await api.get('/api/site/galeria-videos');
      setVideos(response.data);
    } catch (error) {
      toast.error('Erro ao carregar vídeos');
    } finally {
      setLoading(false);
    }
  };

  const fetchViagens = async () => {
    try {
      const response = await api.get('/api/viagens');
      setViagens(response.data);
    } catch (error) {
      console.error('Erro ao carregar viagens:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (videoEdit) {
        await api.put(`/api/site/galeria-videos/${videoEdit.id}`, formData);
        toast.success('Vídeo atualizado com sucesso');
      } else {
        await api.post('/api/site/galeria-videos', formData);
        toast.success('Vídeo adicionado com sucesso');
      }
      setModalOpen(false);
      setVideoEdit(null);
      setFormData({ titulo: '', url: '', descricao: '', ordem: 0, viagem_id: '' });
      fetchVideos();
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao salvar vídeo');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este vídeo?')) return;

    try {
      await api.delete(`/api/site/galeria-videos/${id}`);
      toast.success('Vídeo excluído com sucesso');
      fetchVideos();
    } catch (error) {
      toast.error('Erro ao excluir vídeo');
    }
  };

  const handleEdit = (video) => {
    setVideoEdit(video);
    setFormData({
      titulo: video.titulo || '',
      url: video.url || '',
      descricao: video.descricao || '',
      ordem: video.ordem || 0,
      viagem_id: video.viagem_id || ''
    });
    setModalOpen(true);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-start">
        <div>
          <h1 className="text-3xl font-bold text-white">Gerenciar - Galeria de Vídeos</h1>
          <p className="text-white mt-1">Adicione e gerencie os vídeos da galeria</p>
        </div>
        <button
          onClick={() => {
            setVideoEdit(null);
            setFormData({ titulo: '', url: '', descricao: '', ordem: 0, viagem_id: '' });
            setModalOpen(true);
          }}
          className="flex items-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700"
        >
          <FiPlus className="mr-2" size={20} />
          Adicionar Vídeo
        </button>
      </div>

      {loading ? (
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
        </div>
      ) : (
        <div className="bg-sky-50 rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-sky-200">
              <thead className="bg-sky-100">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase">Título</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase">Viagem</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase">URL</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase">Ordem</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase">Ações</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-sky-200">
                {videos.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="px-6 py-4 text-center text-gray-600 bg-white">
                      Nenhum vídeo cadastrado
                    </td>
                  </tr>
                ) : (
                  videos.map((video) => (
                    <tr key={video.id} className="hover:bg-sky-100 bg-white">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {video.titulo}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-700">
                        {video.viagem_titulo ? (
                          <span className="text-sky-600 font-medium">{video.viagem_titulo}</span>
                        ) : (
                          <span className="text-gray-400">Sem viagem</span>
                        )}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-700">
                        <a href={video.url} target="_blank" rel="noopener noreferrer" className="text-sky-600 hover:text-sky-700">
                          {video.url.length > 50 ? video.url.substring(0, 50) + '...' : video.url}
                        </a>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                        {video.ordem}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm">
                        <div className="flex gap-2">
                          <button
                            onClick={() => handleEdit(video)}
                            className="text-sky-600 hover:text-sky-700"
                          >
                            <FiEdit size={18} />
                          </button>
                          <button
                            onClick={() => handleDelete(video.id)}
                            className="text-red-600 hover:text-red-700"
                          >
                            <FiTrash2 size={18} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full p-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              {videoEdit ? 'Editar Vídeo' : 'Adicionar Vídeo'}
            </h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Viagem (opcional)</label>
                <select
                  value={formData.viagem_id}
                  onChange={(e) => setFormData({ ...formData, viagem_id: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 bg-white text-gray-800"
                >
                  <option value="">Sem viagem específica</option>
                  {viagens.map((viagem) => (
                    <option key={viagem.id} value={viagem.id}>
                      {viagem.titulo}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Título *</label>
                <input
                  type="text"
                  value={formData.titulo}
                  onChange={(e) => setFormData({ ...formData, titulo: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">URL do YouTube *</label>
                <input
                  type="url"
                  value={formData.url}
                  onChange={(e) => setFormData({ ...formData, url: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500"
                  placeholder="https://www.youtube.com/watch?v=..."
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Descrição</label>
                <textarea
                  value={formData.descricao}
                  onChange={(e) => setFormData({ ...formData, descricao: e.target.value })}
                  rows={3}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ordem</label>
                <input
                  type="number"
                  value={formData.ordem}
                  onChange={(e) => setFormData({ ...formData, ordem: parseInt(e.target.value) || 0 })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500"
                  min="0"
                />
              </div>
              <div className="flex justify-end gap-4 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    setModalOpen(false);
                    setVideoEdit(null);
                  }}
                  className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700"
                >
                  {videoEdit ? 'Atualizar' : 'Adicionar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default GerenciarGaleriaVideos;
